var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphsButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.245,
    height: 30.199,
    viewBox: "0 0 30.245 30.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 16.452,
    height: 16.529,
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(-51.681 -1740)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5396",
    "data-name": "Path 5396",
    transform: "translate(51.681 1740)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.12264251708984 29.69922065734863 C 11.21665287017822 29.69922065734863 7.544492721557617 28.18050003051758 4.782602310180664 25.42282104492188 C 2.020922422409058 22.66534996032715 0.5000025033950806 18.99916076660156 0.5000025033950806 15.09961032867432 C 0.5000025033950806 11.20005989074707 2.020922422409058 7.533870220184326 4.782602310180664 4.776400566101074 C 7.544492721557617 2.018720388412476 11.21665287017822 0.5000003576278687 15.12264251708984 0.5000003576278687 C 19.02863311767578 0.5000003576278687 22.70080184936523 2.018720388412476 25.46268272399902 4.776400566101074 C 28.22436332702637 7.533870220184326 29.74528312683105 11.20005989074707 29.74528312683105 15.09961032867432 C 29.74528312683105 18.99916076660156 28.22436332702637 22.66534996032715 25.46268272399902 25.42282104492188 C 22.70080184936523 28.18050003051758 19.02863311767578 29.69922065734863 15.12264251708984 29.69922065734863 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.12264251708984 1 C 11.35006332397461 1 7.803361892700195 2.46681022644043 5.135883331298828 5.130220413208008 C 2.468822479248047 7.793230056762695 1.000001907348633 11.33376121520996 1.000001907348633 15.09961032867432 C 1.000001907348633 18.86545944213867 2.468822479248047 22.40599060058594 5.135883331298828 25.06900024414062 C 7.803361892700195 27.7324104309082 11.35006332397461 29.19922065734863 15.12264251708984 29.19922065734863 C 18.89522171020508 29.19922065734863 22.44192314147949 27.7324104309082 25.1093921661377 25.06900024414062 C 27.77646255493164 22.40599060058594 29.24528312683105 18.86545944213867 29.24528312683105 15.09961032867432 C 29.24528312683105 11.33376121520996 27.77646255493164 7.793230056762695 25.1093921661377 5.130220413208008 C 22.44192314147949 2.46681022644043 18.89522171020508 1 15.12264251708984 1 M 15.12264251708984 0 C 23.47464370727539 0 30.24528312683105 6.760330200195312 30.24528312683105 15.09961032867432 C 30.24528312683105 23.43889045715332 23.47464370727539 30.19922065734863 15.12264251708984 30.19922065734863 C 6.770631790161133 30.19922065734863 1.9073486328125e-06 23.43889045715332 1.9073486328125e-06 15.09961032867432 C 1.9073486328125e-06 6.760330200195312 6.770631790161133 0 15.12264251708984 0 Z",
    stroke: "none",
    fill: "#065683"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(58.849 1747.053)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M5.49,7.082H1.02A1.021,1.021,0,0,1,0,6.062V1.019A1.021,1.021,0,0,1,1.02,0H6.063a1.021,1.021,0,0,1,1.02,1.02V5.489A1.6,1.6,0,0,1,5.49,7.082M1.72,5.936H5.364a.573.573,0,0,0,.573-.573V1.719a.573.573,0,0,0-.573-.573H1.72a.573.573,0,0,0-.573.573V5.363a.573.573,0,0,0,.573.573",
    transform: "translate(0 0.001)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M6.063,82.108H1.02A1.021,1.021,0,0,1,0,81.088V76.045a1.021,1.021,0,0,1,1.02-1.02H6.063a1.021,1.021,0,0,1,1.02,1.02v5.043a1.021,1.021,0,0,1-1.02,1.02M1.72,80.962H5.364a.573.573,0,0,0,.573-.573V76.745a.573.573,0,0,0-.573-.573H1.72a.573.573,0,0,0-.573.573v3.644a.573.573,0,0,0,.573.573",
    transform: "translate(0 -65.58)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M66.128,10.048h7.053a.573.573,0,0,1,0,1.147H66.128a.573.573,0,0,1,0-1.147",
    transform: "translate(-57.302 -8.783)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M66.128,37.11H70.28a.573.573,0,1,1,0,1.146H66.128a.573.573,0,0,1,0-1.146",
    transform: "translate(-57.302 -32.438)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M66.128,85.074h7.053a.573.573,0,0,1,0,1.146H66.128a.573.573,0,0,1,0-1.146",
    transform: "translate(-57.302 -74.364)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M66.128,112.136H70.28a.573.573,0,1,1,0,1.147H66.128a.573.573,0,0,1,0-1.147",
    transform: "translate(-57.302 -98.019)",
    fill: "#065683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphsButton);
export default __webpack_public_path__ + "static/media/graphs_button.9fec833de370c0cd032c398c8ca75f62.svg";
export { ForwardRef as ReactComponent };